export const getCookie = name => {
  try {
    const decodedCookie = decodeURIComponent(document.cookie);
    const v = decodedCookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  } catch (e) {
    return null;
  }
};

export const getCookieObject = name => {
  const value = getCookie(name);
  return value ? JSON.parse(value) : null;
};

export const putCookieObject = (name, obj, options = {}) => {
  const { path = '/', encoded = true } = options;
  const cookiePath = `;path=${path}`;
  const value = JSON.stringify(obj);
  document.cookie = `${name}=${
    encoded ? encodeURIComponent(value) : value
  }${cookiePath}`;
};
